import React, { useEffect, useState } from 'react'
import SlideUpWrapper from '../../../../components/Transitions/SlideUpWrapper'
import TopTitleBar from '../TopTitleBar'
import ShimmerLoader from '../../../../components/ShimmerLoader'
import Loader from '../../../../components/Loader'
import { useLocation, useNavigate } from 'react-router-dom'
import API from "../../../../ApiConfig"
import { BASE_URL, GET_APPEALS, USER_TOKEN } from '../../../../Utils/constant'
import { _ToNormal, setDate } from '../../../../Utils/helper'
import useRefreshToken from '../../../../Hooks/usegenerateToken'
import { useSelector } from 'react-redux'
import Pagination from '../Pagination'
import PageSizeSelector from '../../../../Utils/PageSizeSelector'
import CustomDropDown from '../../../../components/CustomDropDown'
import style from "../../../DashBoard/CompanyProfile.module.css"
const VerifierAppeal = ({id}) => {

useRefreshToken(BASE_URL + USER_TOKEN)
const[loading, setLoading]=useState(false)
const [search, setSearch]=useState("")

const User=useSelector(state=>state.User)
const [currentAppeals, setCurrentAppeals]=useState([])
const [currentPage, setCurrentPage]=useState(1)
const [totalPages, setTotalPages]=useState(1)
const navigate=useNavigate();
const[pageSize, setPageSize]=useState(10)
const Status = [
  "all_appeals", "pending_on_issuer", "approved", "denied","issuer_added_different_value"
]
const [selectedValue, setSelectedValue] = useState("all_appeals")

const location=useLocation()
useEffect(()=>{
    if(location.state=="pending_on_issuer")
    setSelectedValue("pending_on_issuer")
  },[location])

const handleNavigate=(i)=>{
    navigate(`/dashboard/doc_descrepency_details/${i.id}`)
}

useEffect(()=>{
  const delayDebounce=setTimeout(()=>{
    handleAppealRecords()    
  },500)

  return ()=>clearTimeout(delayDebounce)
},[search,currentPage, pageSize, selectedValue])

const handleAppealRecords=()=>{
  setLoading(true)

  API.get(GET_APPEALS,{
    params:{
      status:selectedValue,
      issuer_company_id:User.company_id,
      page:currentPage,
      search:search,
      per_page:pageSize
    }
  })
  .then(res=>{
    if(res.data.status==200){
      setLoading(false)
      setCurrentAppeals(res.data.data.items)
      setTotalPages(res.data.data.total_pages)
    }    
  })

  .catch(err=>{
    setLoading(false)   
  })
}
const handleSearch=(e)=>{
  setSearch(e)
  setCurrentPage(1)
}
const handlePageChange = (newPage) => {
  setCurrentPage(newPage);
}

const handlePageSize=(newSize)=>{
  setPageSize(newSize)
  setCurrentPage(1)
}
  return (
    <>
     <SlideUpWrapper>
        <TopTitleBar isChild>
          <h2 className="topTitleBarText">
            <span className="secondaryButton1">Appeals</span>
          </h2>
        </TopTitleBar>
        <div>
          {/* <section className="table-header6"> */}
            <div className={style.searchContainer}>
            <div className="inputField2">
              <div className="input1">
                <div className="content1">
                  <img
                    className="searchOutlineIcon1"
                    alt=""
                    src="/searchoutline.svg"
                  />
                  <input
                    value={search}
                    onChange={(e) => handleSearch(e.target.value)}
                    className="inputText1"
                    placeholder="Search"
                  />
                </div>
              </div>
              </div>
              <div style={{ margin: "1rem" }}>
                        <div className="exportRecords">
                          <div style={{ margin: "0px 10px" }}>
                            <CustomDropDown
                              list={Status}
                              selectedOption={selectedValue}
                              onSelect={(e) => {setSelectedValue(e); setCurrentPage(1)}}
                            />
                          </div>
                        </div>
                        </div>
            </div>
          {/* </section> */}
          <Loader isOpen={loading} />
          <div className="credentials-table">
            <table style={{ borderRadius: "10px" }}>
              <tr className="credentials-header bg-lgray">

                <th className="credentials-th">
                  <div className="credentials-table-text">Search ID</div>
                </th>
                <th className="credentials-th">
                  <div className="credentials-table-text">Emp ID</div>
                </th>
                <th className="credentials-th">
                  <div className="credentials-table-text">Raised On</div>
                </th>

                <th className="credentials-th">
                  <div className="credentials-table-text">Verifier Name</div>
                </th>
                <th className="credentials-th">
                  <div className="credentials-table-text">Request Status</div>
                </th>
                <th className="credentials-th justify-content-center">
                  <div className="credentials-table-text">Verifier Remarks</div>
                </th>
                <th className="credentials-th justify-content-center">
                  <div className="credentials-table-text">Actions</div>
                </th>

              </tr>
              {loading ? <>
                <tr className="credentials-tr" >
                  <td className="credentials-td">
                    <div className="credentials-table-text"> <ShimmerLoader width='10rem' height='1.5rem' /></div>
                  </td>
                  <td className="credentials-td">
                    <div className="credentials-table-text"><ShimmerLoader width='7rem' height='1.5rem' /></div>
                  </td>
                  <td className="credentials-td">
                    <div className="credentials-table-text"> <ShimmerLoader width='7rem' height='1.5rem' /></div>
                  </td>
                  <td className="credentials-td">
                    <div className="credentials-table-text"> <ShimmerLoader width='7rem' height='1.5rem' /></div>
                  </td>
                </tr>
                <tr className="credentials-tr" >
                  <td className="credentials-td">
                    <div className="credentials-table-text"> <ShimmerLoader width='10rem' height='1.5rem' /></div>
                  </td>
                  <td className="credentials-td">
                    <div className="credentials-table-text"><ShimmerLoader width='7rem' height='1.5rem' /></div>
                  </td>
                  <td className="credentials-td">
                    <div className="credentials-table-text"> <ShimmerLoader width='7rem' height='1.5rem' /></div>
                  </td>
                  <td className="credentials-td">
                    <div className="credentials-table-text"> <ShimmerLoader width='7rem' height='1.5rem' /></div>
                  </td>
                </tr>
              </> : currentAppeals.length === 0 ?
                <tr className="credentials-tr">
                  <td colSpan="6" className="credentials-td text-center">
                    <div className="Data_List">No Appeal Raised</div>
                  </td>
                </tr>
                :
                <>
                  {currentAppeals.map((i, index) => {
                    return (
                      <tr className="credentials-tr" style={{ animationDelay: `${index * 0.1}s` }}>
                        <td className="credentials-td">
                          <div className="credentials-table-text1">{i.id}</div>
                        </td>
                        <td className="credentials-td">
                          <div className="credentials-table-text1">{i.employee_id}</div>
                        </td>
                        <td className="credentials-td">
                          <div className="credentials-table-text1">{setDate(i.created_at)}</div>
                        </td>
                        <td className="credentials-td">
                          <div className="credentials-table-text1">{i.verifier_name}</div>
                        </td>
                        <td className="credentials-td">
                          <div className={`credentials-table-text ${i.status=="APPROVED"?"Complete":i.status=="DENIED"?"Rejected":"Pending"}`} style={{width:"auto", height:"auto"}}>{_ToNormal(i.status)}</div>
                        </td>
                        <td className="credentials-td">
                          <div className={`credentials-table-text1 Remarks`} title={i.verifier_remarks}>{i.verifier_remarks}</div>
                        </td>
                        <td className="credentials-td Action-row">
                          <button className={"btn btn-primary"} onClick={()=>handleNavigate(i)}>View</button>
                        </td>
                      </tr>)
                  })}
                </>}
            </table>
          </div >
          <div style={{ margin: "10px" }}>
             <PageSizeSelector value={pageSize} onChange={handlePageSize}/>
                        <Pagination
                            nPages={totalPages}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            onPageChange={handlePageChange}
                            loading={loading}
                        />
                    </div>
        </div>
      </SlideUpWrapper>
    </>
  )
}

export default VerifierAppeal